import moment from 'moment'
import objectPath from 'object-path'
import initialState from './initialState'

const mutations = {
  setCollection(state, payload) {
    state.collection = payload
  },
  clearCurrentLocations(state) {
    state.form.locations = initialState().form.locations
  },
  updateCollection(state, payload) {
    state.collection = [
      ...state.collection,
      ...payload
    ]
  },
  setCollectionFilters(state, payload) {
    state.collectionFilters = {
      ...state.collectionFilters,
      ...payload
    }
  },
  setMinPrices(state, payload) {
    state.minPrices = {
      ...state.minPrices,
      ...payload
    }
  },
  setField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setPlace(state, { slug, type, name }) {
    state.form.placeToId = slug
    state.form.placeToType = type
    state.form.placeName = name
  },
  setSearchFieldsFromQueryParams(state, payload) {
    const { filters, ...form } = payload

    state.filters = {
      ...state.filters,
      ...filters
    }

    if (form.locations) {
      Object.keys(form.locations).forEach((key) => {
        form.locations[key] = {
          ...form.locations[key],
          name: form.locations[key].name ? decodeURI(form.locations[key].name) : null
        }
      })
    }

    form.locations = {
      ...initialState().form.locations,
      ...form.locations
    }

    if (form.placeFrom) {
      form.placeFrom.name = decodeURI(form.placeFrom.name)
    }

    state.form = {
      ...state.form,
      ...form,
      page: 1
    }
  },
  updatePagination(state, payload) {
    state.pagination = {
      ...state.pagination,
      ...payload
    }
  },
  setIsLoading(state, payload) {
    state.isLoading = payload
  },
  setIsLoadingMore(state, isLoading) {
    state.isLoadingMore = isLoading
  },
  setFormShowed(state, isShowed) {
    state.showForm = isShowed
  },
  setSearchShowed(state, isShowed) {
    state.showSearch = isShowed
  },
  setInitialState() {
    this.state.toursSearch = initialState()
  },
  setErrors(state, errors) {
    state.formErrors = errors
  },
  setDepartureCities(state, payload) {
    state.departureCities = {
      ...state.departureCities,
      ...payload
    }
  },
  setIsFiltersApplied(state, payload) {
    state.isFiltersApplied = payload
  },
  clearFilters(state) {
    state.filters = initialState().filters
  },
  setEmptySearchResults(state, payload) {
    state.isEmptySearchResults = payload
  },
  setIsFiltersDisabled(state, payload) {
    state.isFiltersDisabled = payload
  },
  setIsUpdating(state, payload) {
    state.isUpdating = payload
  },
  setCalendar(state, payload) {
    state.markedDates = payload.map(item => ({
      date: moment.unix(item).toDate(),
      type: 'is-success'
    }))
  },
  setIsCalendarLoading(state, payload) {
    state.isCalendarLoading = payload
  }
}

export default mutations